import type { CSSProperties } from 'react';

/**
 * Phosphor duotone through @phosphor-icons/web: the design ships icon names as
 * class strings ("ph-duotone ph-timer"), and content files carry bare names
 * ("shield-check"). Both are accepted.
 */
export function Icon({ name, size = 22, color, style }: { name?: string; size?: number; color?: string; style?: CSSProperties }) {
  if (!name) return null;
  const className = name.includes('ph-') ? name : `ph-duotone ph-${name}`;
  return <i className={className} aria-hidden="true" style={{ fontSize: size, color, lineHeight: 1, ...style }} />;
}

export const iconClass = (name?: string): string =>
  !name ? '' : name.includes('ph-') ? name : `ph-duotone ph-${name}`;
